/**
 * Resolve an item to a single display URL. Mirrors the mobile app's
 * utils/getItemPhoto.ts so items appear consistently on both platforms.
 *
 * Fallback order matches how items get their photos in this app:
 *   1. photos[] (the canonical Photo[] shape) — user's own uploads
 *   2. swatchPhotos / bottlePhotos / macroPhotos / inUsePhotos / photoUrls —
 *      legacy web-shape fields kept for backwards compat
 *   3. photoUrl — set by the catalog-search "pre-fill" flow when the user
 *      picks a catalog result without uploading their own photo. Without
 *      this fallback, items added via search-existing appear as no-image
 *      tiles on web even though a catalog cover is remembered on the doc.
 */
export function getItemPhoto(item: Record<string, any>): string | null {
  if (Array.isArray(item.photos) && item.photos.length > 0) {
    const def = item.photos.find((p: any) => p?.isDefault && p?.url);
    if (def?.url) return def.url;
    const firstObj = item.photos.find((p: any) => p?.url);
    if (firstObj?.url) return firstObj.url;
    if (typeof item.photos[0] === 'string') return item.photos[0];
  }
  for (const field of ['swatchPhotos', 'bottlePhotos', 'macroPhotos', 'inUsePhotos', 'photoUrls']) {
    const arr = item[field];
    if (Array.isArray(arr) && arr.length > 0 && typeof arr[0] === 'string') return arr[0];
  }
  if (typeof item.photoUrl === 'string' && item.photoUrl) return item.photoUrl;
  return null;
}
